import { useQuery } from '@tanstack/react-query';

import { apiGetContactDetails } from 'api/acturis/client-center';

import { useClientCenterCustomerPolicyTypes } from '../useClientCenterCustomerPolicyTypes';

import type { ActurisContactDetails } from 'api/quote-marketplace';

export const CLIENT_CENTER_CUSTOMER_PROFILE_KEY =
  'client-center-customer-profile';

export const useClientCenterCustomerProfile = (customerId: string) => {
  const { data, isLoading, error } = useQuery<ActurisContactDetails>({
    queryKey: [CLIENT_CENTER_CUSTOMER_PROFILE_KEY, customerId],
    queryFn: () => apiGetContactDetails(customerId),
    enabled: Boolean(customerId),
    staleTime: 30 * 1000,
    retry: false,
  });

  const { policyTypes, isLoading: isPolicyTypesLoading } =
    useClientCenterCustomerPolicyTypes(customerId);

  return {
    profile: data,
    isLoading,
    error,
    policyTypes,
    isPolicyTypesLoading,
  };
};
